import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const productImageUrl = (img) => {
  if (!img) return null;
  return img.startsWith("/") ? img : `${BACKEND_URL}/api/files/${img}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
